"use client";

import { ReactNode } from "react";
import { Dialog as MuiDialog } from "@mui/material";
import { useCloneDialog } from "../Providers/CloneDialogContext";

interface DialogProps {
  children: ReactNode;
}

export default function Dialog({ children }: DialogProps) {
  const { cloneDialogOpen, closeCloneDialog } = useCloneDialog();

  return (
    <MuiDialog open={cloneDialogOpen} onClose={closeCloneDialog}>
      {children}
    </MuiDialog>
  );
}
